(function() {
'use strict';

angular
    .module('TR')
    .controller('TestDestination', TestDestination);

function TestDestination() {
    const cm = this;

    cm.LocationName = 'Alcatraz';


    //cm.activeTabId = 'cakes';


}
})();
